import React, { useContext } from "react";
import LoginInfoContext from "../Context/LoginInfoContext";

const Logout = () => {
    const { isHidden, logoutCallback } = useContext(LoginInfoContext);

    return (
        <>
            {isHidden && (
                <div className="user_status">
                    <input
                        type="button"
                        value="Logout"
                        className="logout"
                        onClick={logoutCallback}
                    />
                </div>
            )}
        </>
    );
};
export default Logout;
